import { gsap } from '@theme/gsap';
import { ScrollTrigger } from '@theme/gsap-scrolltrigger';
import { SplitText } from '@theme/gsap-splittext';
import { HTMLCustomElement } from '@theme/html-custom-element';

class ScrollProgressText extends HTMLCustomElement {
  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    gsap.registerPlugin(ScrollTrigger, SplitText);

    const split = SplitText.create(this.refs.text ?? this.firstElementChild, {
      type: 'words, chars',
    });

    gsap.to(split.chars, {
      color: 'var(--color-black)',
      stagger: 1,
      scrollTrigger: {
        trigger: this.closest('.shopify-section'),
        scrub: true,
        start: 'top bottom-=20%',
        end: 'bottom bottom',
      },
    });
  }
}

if (!customElements.get('scroll-progress-text')) customElements.define('scroll-progress-text', ScrollProgressText);
